import { Toast } from '@base-ui/react'

export const snackbarStore = Toast.createToastManager()
